module.exports = __webpack_public_path__ + "img/克里特易.ec00a825.png";